import './index.scss'
$(".product-nav dt").click(function() {
    $(this).toggleClass("active");
    $(this).parent().find('.dd').slideToggle();
})